<template>
    <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between gap-4">
            <div>
                <span class="text-base font-extrabold text-slate-700 text-md">{{ props.title }}</span>
                <div v-if="props.subtitle" class="text-sm text-slate-700">{{ props.subtitle }}</div>
            </div>
            <div class="shrink-0">
                <vx-toggle
                    v-model="model"
                    :disabled="props.disabled"
                    :size="props.size"
                ></vx-toggle>
            </div>
        </div>
        <animate-height v-if="$slots.default" :height="model ? 'auto' : 0" :animateOpacity="true">
            <div>
                <slot> </slot>
            </div>
        </animate-height>
    </div>
</template>

<script lang="ts" setup>
import { VxToggle } from '@voxie/frontend-components';
import AnimateHeight from 'vue-animate-height';

interface Props {
    title: string;
    subtitle?: string;
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    size: 'lg',
    disabled: false,
});

const model = defineModel<boolean>({ required: true });
</script>
